import React from 'react';
import PropTypes from 'prop-types';
import fieldSelection from '..';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  component: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
}));

const Fields = ({ id, tab, props }) => {
  const classes = useStyles();
  return (
    <div className={classes.component}>
      {tab.fields.map((item, key) => {
        const config = { ...item };

        if (!config.useCustomFieldName) {
          config.field = `${id}.${tab.label}.${item.field}`;
          config.isNested = true;
        }

        return fieldSelection({ id: item.id, item: config, props, key });
      })}
    </div>
  );
};

Fields.propTypes = {
  id: PropTypes.string,
  tab: PropTypes.object,
  props: PropTypes.object,
};

export default Fields;
